import { createSelector } from 'reselect';
import getMenu from './getMenu';

export default createSelector([getMenu], (menu): CategoryInfo[] | undefined => {
  return menu?.allCategoryInfo || [];
});
